import React from 'react';

export default function CartEta({eta}) {
  const {etaIsExists, etaText} = eta;

  return (
    <>
      {etaIsExists &&
        <div className="app-cart-eta">
          <div className="app-cart-line">
            <div className="app-cart-line-left">
              <span className="app-cart-text-parameter">ETA</span>
            </div>
            <div className="app-cart-line-right">
              <span className="app-cart-text-value">{etaText}</span>
            </div>
          </div>
        </div>
      }
    </>
  )
}
